import { ConversationChatTsConnectionSocketForMonitoringProvider } from 'hooks/useSocketConversationChatTs';
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import routes from 'routes';

const MonitoringLayout = () => {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/monitoring' || prop.layout === '/monitoringChat') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
            exact={prop.exact}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <ConversationChatTsConnectionSocketForMonitoringProvider>
      <div>
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/admin/dashboard" />
        </Switch>
      </div>
    </ConversationChatTsConnectionSocketForMonitoringProvider>
  );
};

export default MonitoringLayout;
